import React from "react";
import { StaticImage } from "gatsby-plugin-image";

function team() {
	return (
		<section
			id="team"
			data-sal-duration="1000"
			data-sal="slide-up"
			data-sal-delay="300"
			data-sal-easing="ease-out-bounce"
		>
			<div className="team_wrapper">
				<div className="team-intro">
					<h1>Our creative team</h1>
					<p>Meet our creative team</p>
				</div>
				<div className="team_container">
					<div className="team_member">
						<div className="member_img">
							<StaticImage
								className="slider_item_image"
								src="../images/users/spacevic.jpg"
								alt="project one"
							/>
						</div>
						<div className="member_details">
							<div className="member_name">
								<h1>VICTOR NGANDA</h1>
								<div className="social_icons">
									<a href="!#">
										<svg
											version="1.1"
											id="Capa_1"
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											viewBox="0 0 290 290"
											xmlSpace="preserve"
										>
											<path
												d="M205.807,0h-15.694c-43.62,0-79.107,35.488-79.107,79.108v33.386H84.193c-2.761,0-5,2.239-5,5v40c0,2.761,2.239,5,5,5
	h26.811V285c0,2.761,2.239,5,5,5h40c2.761,0,5-2.239,5-5V162.494h39.786c2.761,0,5-2.239,5-5v-40c0-2.761-2.239-5-5-5h-39.786
	V79.108c0-16.05,13.058-29.108,29.107-29.108h15.694c2.761,0,5-2.239,5-5V5C210.807,2.239,208.568,0,205.807,0z"
											/>
										</svg>
									</a>
									<a href="!#">
										<svg
											version="1.1"
											id="Layer_1"
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											viewBox="0 0 169.063 169.063"
											xmlSpace="preserve"
										>
											<g>
												<path
													d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
		c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
		c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
		c17.455,0,31.656,14.201,31.656,31.655V122.407z"
												/>
												<path
													d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
		C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
		c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
												/>
												<path
													d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
		c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
		C135.661,29.421,132.821,28.251,129.921,28.251z"
												/>
											</g>
										</svg>
									</a>
								</div>
							</div>
							<div className="member_role">
								<h2>Designer</h2>
							</div>
						</div>
					</div>
					<div className="team_member">
						<div className="member_img">
							<StaticImage
								className="slider_item_image"
								src="../images/users/bonfanty.jpg"
								alt="project one"
							/>
						</div>
						<div className="member_details">
							<div className="social-media"></div>
							<div className="member_name">
								<h1>Bontfany Ndilinge</h1>
								<div className="social_icons">
									<a href="!#">
										<svg
											version="1.1"
											id="Capa_1"
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											viewBox="0 0 290 290"
											xmlSpace="preserve"
										>
											<path
												d="M205.807,0h-15.694c-43.62,0-79.107,35.488-79.107,79.108v33.386H84.193c-2.761,0-5,2.239-5,5v40c0,2.761,2.239,5,5,5
	h26.811V285c0,2.761,2.239,5,5,5h40c2.761,0,5-2.239,5-5V162.494h39.786c2.761,0,5-2.239,5-5v-40c0-2.761-2.239-5-5-5h-39.786
	V79.108c0-16.05,13.058-29.108,29.107-29.108h15.694c2.761,0,5-2.239,5-5V5C210.807,2.239,208.568,0,205.807,0z"
											/>
										</svg>
									</a>
									<a href="!#">
										<svg
											version="1.1"
											id="Layer_1"
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											viewBox="0 0 169.063 169.063"
											xmlSpace="preserve"
										>
											<g>
												<path
													d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
		c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
		c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
		c17.455,0,31.656,14.201,31.656,31.655V122.407z"
												/>
												<path
													d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
		C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
		c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
												/>
												<path
													d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
		c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
		C135.661,29.421,132.821,28.251,129.921,28.251z"
												/>
											</g>
										</svg>
									</a>
								</div>
							</div>
							<div className="member_role">
								<h2>Designer</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default team;
